module.exports = __webpack_public_path__ + "img/indicator_3.e472a837.png";